import { mapState } from "vuex"

import events_mixin from "~/mixins/events"
import cache_mixin from "~/mixins/cache"

export default {
  mixins: [events_mixin, cache_mixin],
  computed: {
    ...mapState({
      is_paypal: (state) => state.payin.payment_method.selected === "paypal",
      DRAFT_ID: (state) => state.draft.id,
    }),
  },
  methods: {
    pre_pay_actions() {
      return new Promise((resolve) => {
        this.trackEvent({
          category: "Payin",
          action: "PaymentAttempt",
          ...this.$store.getters["payin/LOOSE_EVENT_DATA"],
        })
        resolve()
      })
    },
    post_pay_actions(secureUrl) {
      try {
        this.trackStandardEvent(
          "purchase",
          this.is_paypal ? "paypal" : "mangopay",
          {
            ...this.$store.getters["payin/STANDARD_EVENT_DATA"],
          }
        )

        this.$axios
          .$get("/wallet/payment-occurences/")
          .then(({ payment_occurences }) => {
            this.trackEvent({
              category: "Payin",
              action: "Payment",
              occurence_number: payment_occurences,
              ...this.$store.getters["payin/LOOSE_EVENT_DATA"],
            })
          })
          .catch((err) => {
            this.$sentry.captureException(err)
          })
        this.cleanDraftProgress(this.DRAFT_ID)
        this.cleanCacheAll()
        if (!secureUrl) {
          this.trackEvent({
            category: "Campaign",
            action: "Launch campaign",
            origin: "classic",
            draft: this.DRAFT_ID,
          })
        }
      } catch (err) {
        this.$sentry.captureException(err)
      }
      if (!secureUrl) {
        window.location.href =
          this.$store.getters["payin/PURCHASE_TYPE"] === "sendtrack"
            ? `${location.origin}/draft/${this.DRAFT_ID}/finalized`
            : "/band/shop/finalized"
      } else {
        window.location.href = secureUrl
      }
    },
    pay: function () {
      this.pre_pay_actions()
      this.$store
        .dispatch("payin/PAY")
        .then((secureUrl) => {
          this.post_pay_actions(secureUrl)
        })
        .catch((err) => {
          this.$sentry.captureException(err)
          this.$store.commit("payin/SET_PROCESSING_STATUS", false)
        })
    },
    lock_safeguard_loop: function (data, tries, url, axios) {
      return new Promise(
        async function (resolve, reject) {
          axios(`${url}lock/`, data)
            .then((resp) => {
              resolve(resp)
            })
            .catch((err) => {
              if (tries < 150) {
                window.setTimeout(
                  function () {
                    this.lock_safeguard_loop(data, tries + 1, url, axios)
                  }.bind(this),
                  1000 * tries
                )
              } else reject(err)
            })
        }.bind(this)
      )
    },
    lock_safeguard: function (try_promise, data, url, axios) {
      if (typeof axios === "undefined") axios = this.$axios
      return new Promise((resolve, reject) => {
        try_promise()
          .then((resp) => {
            resolve(resp)
          })
          .catch((error) => {
            if (error?.response?.status === 409) {
              this.lock_safeguard_loop(data, 0, url, axios)
                .then((resp) => {
                  resolve(resp)
                })
                .catch((resp) => {
                  reject(resp)
                })
            } else reject(error)
          })
      })
    },
  },
}
